import PriceWidthrawlImportPage from './PriceWidthrawlImportPage';

export default PriceWidthrawlImportPage;
